import classNames from "classnames";
import { PropsWithChildren } from "react";
import theme from "../../../../../theme"

type BadgeProps = {
  content?: string;
  offsetX?: number;
  offsetY?: number;
  position?: BadgePositions;
  hidden?: boolean;
  badgeColor?: string;
  className?: string;
} & PropsWithChildren & React.HTMLAttributes<HTMLSpanElement>;

enum BadgePosition {
  TopRight,
}

type BadgePositions = BadgePosition.TopRight;

export function Badge({
  content = "",
  offsetX = 0,
  offsetY = 0,
  position = BadgePosition.TopRight,
  hidden = false,
  badgeColor = theme.colours["brand-orange"],
  className,
  children,
  ...rest
}: BadgeProps) {
  const positionClasses: Record<BadgePosition, string> = {
    [BadgePosition.TopRight]: "top-0 right-0 translate-x-1/2 -translate-y-1/2",
  };

  return (
    <div data-testid="badge-wrapper" className={classNames("relative", className)} >
      {children}

      <span
        {...rest}
        className={
          classNames(
            "pointer-events-none min-w-[14px] min-h-[14px] absolute flex items-center justify-center rounded-full bg-red-500 text-white text-xs font-bold",
            positionClasses[position],
            content !== "" && "px-1",
            {
              "hidden": hidden
            }
          )
        }
        style={{
          marginTop: offsetY,
          marginRight: offsetX,
          backgroundColor: badgeColor
        }}
      >
        {content}
      </span >
    </div >
  );
}
